import React from "react";
import { Accordion } from "react-bootstrap";
import languageStorage from "../lang/findLanguage";

export default function FAQ({ language }) {
  // id={languageStorage() === "tr" ? language[0].sections[11].keys[4].k0005 : language[1].sections[11].keys[4].k0005}
  return (
    <div className="faq">
      <div className="container">
        <h3>{languageStorage() === "tr" ? language[0].sections[7].keys[0].k0001 : language[1].sections[7].keys[0].k0001}</h3>
        <p className="desc">
          {languageStorage() === "tr" ? language[0].sections[7].keys[1].k0002 : language[1].sections[7].keys[1].k0002}{" "}
          <a href={`#${languageStorage() === "tr" ? language[0].sections[11].keys[5].k0006 : language[1].sections[11].keys[5].k0006}`}>
            {languageStorage() === "tr" ? language[0].sections[7].keys[2].k0003 : language[1].sections[7].keys[2].k0003}
          </a>
        </p>
        {/* defaultActiveKey="0" */}
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>{languageStorage() === "tr" ? language[0].sections[7].keys[3].k0004 : language[1].sections[7].keys[3].k0004}</Accordion.Header>
            <Accordion.Body>
              <p>{languageStorage() === "tr" ? language[0].sections[7].keys[4].k0005 : language[1].sections[7].keys[4].k0005}</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>{languageStorage() === "tr" ? language[0].sections[7].keys[5].k0006 : language[1].sections[7].keys[5].k0006}</Accordion.Header>
            <Accordion.Body>
              <p>{languageStorage() === "tr" ? language[0].sections[7].keys[6].k0007 : language[1].sections[7].keys[6].k0007}</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>{languageStorage() === "tr" ? language[0].sections[7].keys[7].k0008 : language[1].sections[7].keys[7].k0008}</Accordion.Header>
            <Accordion.Body>
              <p>{languageStorage() === "tr" ? language[0].sections[7].keys[8].k0009 : language[1].sections[7].keys[8].k0009}</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>{languageStorage() === "tr" ? language[0].sections[7].keys[9].k0010 : language[1].sections[7].keys[9].k0010}</Accordion.Header>
            <Accordion.Body>
              <p>
                {languageStorage() === "tr" ? language[0].sections[7].keys[10].k0011 : language[1].sections[7].keys[10].k0011} <br /> <br />
                {languageStorage() === "tr" ? language[0].sections[7].keys[11].k0012 : language[1].sections[7].keys[11].k0012}
              </p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </div>
  );
}
